
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductBillingItemsDialog extends Serenity.EntityDialog<ProductBillingItemsRow, any> {
        protected getFormKey() { return ProductBillingItemsForm.formKey; }
        protected getIdProperty() { return ProductBillingItemsRow.idProperty; }
        protected getLocalTextPrefix() { return ProductBillingItemsRow.localTextPrefix; }
        protected getNameProperty() { return ProductBillingItemsRow.nameProperty; }
        protected getService() { return ProductBillingItemsService.baseUrl; }
        protected getDeletePermission() { return ProductBillingItemsRow.deletePermission; }
        protected getInsertPermission() { return ProductBillingItemsRow.insertPermission; }
        protected getUpdatePermission() { return ProductBillingItemsRow.updatePermission; }

        protected form = new ProductBillingItemsForm(this.idPrefix);

        constructor() {
            super();
            if (this.isNew() == true) {
                Q.reloadLookup("Products.Products");
            }
        }
        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.isNew() == true)
            {
                Q.reloadLookup("Products.Products");
            }
        }
    }
}